export default "__VITE_ASSET__CYjX$9pO__"